import { useBaseContext } from '#base/hooks/use-base-context';
import { useApi } from '#hooks/use-api';
import { CatalogMode } from '#advert/components/card-list';

const useInit = (
  categoryId: number|undefined,
  cityId: number|undefined,
  areaId: number|undefined,
) => {
  const api = useApi();
  const { catalogMode } = useBaseContext();

  return () => {
    if (catalogMode === CatalogMode.default) {
      const {
        data,
        isFetching,
        isError,
        error,
      } = api.getApiAdvertListByDate().useInitQuery({ categoryId, cityId, areaId });

      return {
        data,
        isFetching,
        isError,
        error,
        advertDataListByDate: data?.advertDataList,
      };
    }

    const {
      data,
      isFetching,
      isError,
      error,
    } = api.getApiAdvertListByService().useInitQuery({ categoryId, cityId, areaId });

    return {
      data,
      isFetching,
      isError,
      error,
      advertDataListByService: data?.advertDataList,
    };
  };
};

export { useInit };
